<div>
    <div class="attention-icon">
        <img src="../../../../../assets/images/attention.svg" alt="attention" />
    </div>
    <div>
        <div><a (click)="onLogin()" data-qa-selector="login">Log In</a> or <a href="/registration">Register</a></div>
        <div>To View Price</div>
    </div>
</div>